module.exports = __webpack_public_path__ + "static/media/team-3-800x800.497bb359.jpg";